import getBaseQuery from './getBaseQuery';
import getQueryFilterGroups from './getQueryFilterGroups';
import { buildFilterGroup } from '../../../../core/util/filters';

export default function trafficQuery(queryFilters, asn, peeringInfo) {
  return {
    ...getBaseQuery({ queryFilters, asn }),
    viz_type: 'line',
    filters: {
      connector: 'All',
      filterGroups: []
    },
    aggregates: [
      {
        value: 'avg_bits_per_sec',
        column: 'f_sum_both_bytes',
        fn: 'average',
        label: 'Bits/s Sampled at Ingress + Egress Average',
        unit: 'bytes',
        group: 'Bits/s Sampled at Ingress + Egress',
        origLabel: 'Average',
        sample_rate: 1,
        raw: true,
        name: 'avg_bits_per_sec'
      },
      {
        value: 'p95th_bits_per_sec',
        column: 'f_sum_both_bytes',
        fn: 'percentile',
        label: 'Bits/s Sampled at Ingress + Egress 95th Percentile',
        rank: 95,
        unit: 'bytes',
        group: 'Bits/s Sampled at Ingress + Egress',
        origLabel: '95th Percentile',
        sample_rate: 1,
        name: 'p95th_bits_per_sec'
      },
      {
        value: 'max_bits_per_sec',
        column: 'f_sum_both_bytes',
        fn: 'max',
        label: 'Bits/s Sampled at Ingress + Egress Max',
        unit: 'bytes',
        group: 'Bits/s Sampled at Ingress + Egress',
        origLabel: 'Max',
        sample_rate: 1,
        name: 'max_bits_per_sec'
      }
    ],
    filterDimensionsEnabled: true,
    filterDimensionName: 'Total',
    filterDimensionOther: false,
    filterDimensions: {
      connector: 'All',
      filterGroups: [
        buildFilterGroup({
          name: `Traffic from ${peeringInfo ? peeringInfo.data.name : asn}`,
          named: true,
          filters: [
            { filterField: 'src_as', operator: '=', filterValue: asn },
            { filterField: 'i_src_network_bndry_name', operator: '=', filterValue: 'external' }
          ],
          filterGroups: getQueryFilterGroups(queryFilters, 'src')
        }),
        buildFilterGroup({
          name: `Traffic to ${peeringInfo ? peeringInfo.data.name : asn}`,
          named: true,
          filters: [
            { filterField: 'dst_bgp_aspath', operator: '~', filterValue: `_${asn}_` },
            { filterField: 'i_dst_network_bndry_name', operator: '=', filterValue: 'external' }
          ],
          filterGroups: getQueryFilterGroups(queryFilters, 'dst')
        })
      ]
    }
  };
}
